import React, { ReactElement } from 'react';

import { ProgressiveImage } from '../../../storywind';
import { Text } from '../../storyblocks-design-system/components/atoms/Text/Text';

interface CategoryPillBuilderProps {
  href: string;
  label: string;
  image: string;
}

const CategoryPill = ({
  href = '',
  label = '',
  image,
}: CategoryPillBuilderProps): ReactElement => (
  <a
    className="inline-flex items-center justify-center rounded-full rounded-2xl focus-within:outline-none focus-within:ring-2 focus-within:ring-blue-600 focus-within:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-white text-gray-900 hover:bg-gray-200 px-4 py-2 md:pl-2 md:pr-6 cursor-pointer border-2 border-gray-300 no-underline"
    href={href}
    role="button"
    aria-label={label}
    tabIndex={0}
  >
    <div className="hidden md:block w-14 h-14 overflow-hidden rounded-full mr-2 bg-gray-300">
      <ProgressiveImage
        src={image}
        alt={label}
        width={56}
        height={56}
        className="object-cover w-full h-full"
      />
    </div>
    <Text
      fontSize="2xl"
      fontWeight="regular"
      fontFamily="polysans"
      asChild
      className="pb-0"
    >
      <span>{label}</span>
    </Text>
  </a>
);

export default CategoryPill;
